<template>
  <section
    id="cover"
    class="te-bg-python-ai-set-image relative flex flex-col items-center justify-center bg-cover bg-center px-4 text-center text-white"
    style="height: 520px"
  >
    <span class="co-display-11 mb-4 border-b-4 border-co-info-500 pb-2 font-bold tracking-[.15em]">
      お得な2コースセット
    </span>
    <h1 class="mb-3 flex flex-col items-center font-bold leading-base tracking-[.15em] lg:flex-row">
      <span class="te-title-set drop-shadow-[0_1px_2px_rgba(0,0,0,.3)]">Python</span>
      <FontAwesomeIcon
        :icon="faCirclePlus"
        class="fa-fw co-display-7 hidden size-7 px-2 md:inline-block"
      />
      <span class="te-title-set drop-shadow-[0_1px_2px_rgba(0,0,0,.3)]">AIセット</span>
    </h1>
    <h2 class="co-display-11 mb-1 leading-base drop-shadow-[0_1px_2px_rgba(0,0,0,.3)]">
      Pythonを使ってAIの構築に必要な機械学習・
      <br class="md:hidden">
      ディープラーニング習得
    </h2>
    <!-- 251202導線削除 -->
    <!-- <TeSetTimeSpan :pack="pack" /> -->
    <div class="alert m-4 block w-auto rounded border-[#ffeeba] bg-[#fff3cd] p-2 text-center text-[#856404]">
      お申し込みを停止しております。 再開の際には改めてご案内いたします。
    </div>
    <!-- //- 経済産業省認定バッジ -->
    <TeCommonBadgeReskilling />
  </section>
</template>

<script lang="ts">
import TeSetTimeSpan from '~/components/Te/TeSet/TeSetTimeSpan.vue'
import TeCommonBadgeReskilling from '~/components/Te/TeCommon/Badge/Reskilling/TeCommonBadgeReskilling.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCirclePlus } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

interface Props {
  pack: object
}

const options = {
  async setup() {
    return {
      faCirclePlus,
    }
  },
  props: {
    pack: {
      default: null,
    },
  },
  components: {
    TeSetTimeSpan,
    TeCommonBadgeReskilling,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-bg-python-ai-set-image {
  height: 560px;
  background-image: url('~/assets/images/Te/TeSet/PythonAi/Cover/cover-python-ai-set.jpg');
  @media (min-width: 576px) {
    height: 600px;
  }
  @media (min-width: 768px) {
    height: 520px;
  }
}

/* // セットコース用タイトル */
.te-title-set {
  font-size: 1.25rem;
  @media (min-width: 768px) {
    font-size: 2rem;
  }
}
</style>
